module.exports = __webpack_public_path__ + "img/11.7602f633.jpg";